
<form [formGroup]="loginForm" (submit)="signIn($event)" class="loginForm" >
  <div class="main-page-content-block-secondary"
       style="width: 400px; position: absolute; top: calc(50vh - 250px); left: calc(50vw - 200px);">

    <div class="row" >
      <div class="col mt-1 mb-3 text-center">
        <img src="/assets/Logo_Square_White.png"
             class="bussines-logo"
             alt="ArkMed" />
      </div>
    </div>
    <div class="row" *ngIf="checkingCredential">
      <div class="col mb-3 mt-3 text-center ">
          <span>Validating current credentials. Please wait</span><br />
      </div>
    </div>
    <div class="row" *ngIf="!checkingCredential">
      <div class="col mb-3">
        <label for="Username">Enter user name</label>
        <input class="form-control" name="username" formControlName="username" autocomplete="username" placeholder="username"
               required="required" /> 
      </div>
    </div>
    <div class="row" *ngIf="!checkingCredential">
      <div class="col mb-3">
        <label for="Password">Enter password</label>
        <input class="form-control" type="password" name="password" formControlName="password"
               placeholder="password" autocomplete="current-password" required="required" />
      </div>
    </div>
    <div class="row" *ngIf="authFailedError">
      <div class="col mb-3 justify-content-center">
        <label style="color: red"> {{authFailedError}}</label>
      </div>
    </div>
    <div class="row" *ngIf="!checkingCredential">
      <div class="col text-center">
        <button class="btn btn-lg btn-primary" type="submit" id="btnLogin" [class.button-loading]="loading">Log In</button>
        <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnPasswordReset" [class.button-loading]="loading" (click)="passwordReset()">Password Forgotten</button>
      </div>
    </div>
  </div>
</form>
<div class="itsfine" style="display: none" >

</div>
